<template>
  <div class="content mb-5">
    <b-loading :is-full-page="false" :active.sync="loading" />
    <form class="form width500 centered" @submit.prevent="submit">
      <b-field
        :label="$t('fields.email')"
        :type="{'is-danger': errors.has('email')}"
        :message="errors.first('email')"
      >
        <b-input
          v-model="model.email"
          v-validate="{
            required: true,
            email: {
              allow_utf8_local_part: false
            },
            uniqueEmail: true
          }"
          name="email"
          size="is-medium"
        />
      </b-field>

      <b-field
        :label="$t('register.enterPassword')"
        :type="{'is-danger': errors.has('password')}"
        :message="errors.first('password')"
      >
        <b-input
          v-model="model.password"
          v-validate="'required|min:6'"
          name="password"
          type="password"
          password-reveal
          size="is-medium"
        />
      </b-field>

      <form-phone
        v-if="requiredPhoneToRegistration"
        v-model="model.phone"
        v-validate="'phone|uniquePhone'"
        name="phone"
        size="is-medium"
      >
        {{ $t('fields.phone') }}
      </form-phone>

      <b-field
        v-if="seller"
        :label="$t('fields.company')"
        :type="{'is-danger': errors.has('company')}"
        :message="errors.first('company')"
      >
        <b-input v-model="model.company" v-validate="'required'" name="company" size="is-medium" />
      </b-field>

      <b-field v-if="seller" :label="$t('fields.tin')">
        <b-input v-model="model.tin" name="tin" size="is-medium" />
      </b-field>

      <b-field
        class="m-t-20"
        :type="{'is-danger': errors.has('acceptRegulations')}"
        :message="errors.first('acceptRegulations')"
      >
        <b-checkbox
          v-model="acceptRegulations"
          v-validate="'required:false'"
          name="acceptRegulations"
        >
          <i18n path="checkout.accept_regulations">
            <a @click.prevent="regulationsModal = true">{{ $t('checkout.link') }}</a>
          </i18n>
        </b-checkbox>
      </b-field>

      <div class="form-control m-t-30">
        <button type="submit" class="button is-success is-large is-fullwidth" :disabled="loading || errors.any()">
          {{ $t('register.button_send') }}
        </button>
      </div>

      <socials class="m-b-30" @loading="x => loading = x" />
    </form>
    <b-modal :active.sync="regulationsModal">
      <div class="card">
        <div class="card-content">
          <content-generator :sections="regulations" />
        </div>
      </div>
    </b-modal>
  </div>
</template>

<script>
import Socials from '~/marketplace-front-core/components/auth/Socials'
import FormPhone from '~/marketplace-front-core/components/form/phone'
import loginMixin from '~/marketplace-front-core/mixin/login'
import ContentGenerator from '~/marketplace-front-core/components/contentEditorClient/content.vue'
export default {
  components: { FormPhone, Socials, ContentGenerator },
  mixins: [loginMixin],
  provide () { return { $parentValidator: this.$validator } },
  props: {
    seller: {
      type: Boolean
    }
  },
  data () {
    return {
      regulations: '',
      requiredPhoneToRegistration: process.env.requiredPhoneToRegistration === 'true',
      acceptRegulations: false,
      regulationsModal: false,
      model: {
        email: '',
        password: '',
        phone: '',
        company: '',
        tin: ''
      },
      loading: false
    }
  },
  created () {
    this.$api.cms.url({ url: this.slugRegulations })
      .then((res) => { this.regulations = res.productDescriptionSections })
      .catch(() => { return null })
  },
  methods: {
    submit () {
      this.$validator.validate().then((result) => {
        if (result) {
          this.loading = true
          const data = this._clone(this.model)

          if (!this.requiredPhoneToRegistration) {
            delete data.phone
          }

          delete data.tin
          data.nip = data.tin
          if (!this.seller) {
            delete data.company
            delete data.nip
          }

          this.$api.auth
            .register(this.seller, data)
            .then((result) => {
              this.$buefy.toast.open({
                message: this.$t('register.success'),
                type: 'is-success'
              })
              this.login()
            })
            .catch(() => {
              this.loading = false
              this.$buefy.toast.open({
                message: this.$t('register.error'),
                type: 'is-danger'
              })
            })
        } else {
          this.loading = false
        }
      })
    },
    login () {
      this.$api.auth.login({
        username: this.model.email,
        password: this.model.password
      })
        .then((res) => {
          this.successLogin(res)
        })
        .catch(() => {
          this.errorLogin()
        })
        .finally(() => {
          this.loading = false
        })
    }
  }
}
</script>
